module.exports = __webpack_public_path__ + "static/media/embed-kart2.7a8eeb44.png";